import { render, staticRenderFns } from "./TrangSuaHoSoCanBo.vue?vue&type=template&id=c9e18baa&"
import script from "./TrangSuaHoSoCanBo.vue?vue&type=script&lang=js&"
export * from "./TrangSuaHoSoCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports